<template>
  <v-menu
    ref="DateMenu"
    v-model="dateMenu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="date"
        :label="label || 'Select Date'"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        :hint="hint || 'Select date'">
      </v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      scrollable
      @change="changeHandler()">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="dateMenu = false">Cancel</v-btn>
      <v-btn text color="primary" @click="$refs.DateMenu.save(date)">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<style>
  .v-menu__content {
    min-width: unset !important;
  }
</style>

<script>
export default {
  name: 'DatePicker',
  props: [ 'value', 'label', 'hint'],
  data() {
    return {
      dateMenu: false,
      date: null,
    };
  },
  watch: {
    value() {
      this.date = this.value;
    }
  },
  // mounted() {
  //   this.date = this.value;
  // },
  methods: {
    changeHandler() {
      console.log("changed");
      this.$refs.DateMenu.save(this.date);
      this.$emit('change', this.date);
    }
  }
}
</script>